import cakeImage7 from './../../../assets/images/42.jpg';//יומלדת ורודה 42
import cakeImage2 from './../../../assets/images/33.jpg';//חתונה קומות חלקה בנגיעות רוז
import cakeImage3 from './../../../assets/images/12.jpg';//חתונה פרחים לבנים 12
import cakeImage4 from './../../../assets/images/46.jpg';//חתונה 4 קומות 46
import cakeImage1 from './../../../assets/images/13.jpg';//בר נטיפים בורדו 13
import cakeImage5 from './../../../assets/images/11.jpg';//בר נטיפים צבעוני פירות 11
import cakeImage8 from './../../../assets/images/44.jpg';//יומולדת תמי 44
import cakeImage6 from './../../../assets/images/10.jpg';//בר עם שמנת תותים ונענע 10
import cakeImage9 from './../../../assets/images/16.jpg';//יומולדת צבעונית 16

const RecepiesList = [
  {
    id: 1,
    name: "🍫 Pink Cake with Chocolate Frosting and Flowers",
    image: cakeImage1,
    theRecepie: `
Ingredients:
- 5 eggs
- 1 cup sugar
- 1 cup self-rising flour
- 100 grams dark chocolate
- 1/2 cup heavy cream

Instructions:
1. Whip the eggs with the sugar until light and fluffy.
2. Melt the chocolate with the cream and let it cool slightly.
3. Fold the flour and chocolate mixture into the batter.
4. Bake in a lined pan at 180°C (350°F) for about 30 minutes.
5. Cool, slice, and fill with chocolate cream between the layers.
    `
  },
  {
    id: 2,
    name: "Elegant Tiered Cake",
    image: cakeImage2,
    theRecepie: `
    🧁 For the cake (2 pans of 20 cm + 15 cm):

    2.5 cups flour
    
    2 teaspoons baking powder
    
    1/2 teaspoon salt
    
    200 grams softened butter
    
    1.5 cups sugar
    
    4 eggs
    
    1 tablespoon vanilla extract
    
    1 cup milk
    
    🧁 For the vanilla buttercream:
    
    300 grams softened butter
    
    500 grams powdered sugar
    
    1 teaspoon vanilla extract
    
    Pink food coloring for decoration (roses)
    
    Instructions:
    
    Preheat the oven to 175°C (350°F). Grease the pans.
    
    Mix the dry ingredients. In a separate bowl, whip butter and sugar, then add eggs and vanilla.
    
    Alternate adding milk and flour mixture.
    
    Bake for 30–40 minutes. Cool completely.
    
    Prepare the buttercream, decorate the cakes, and assemble the tiers with supports.
    `
  },
  {
    id: 3,
    name: "🍰 Naked Cake with White Roses",
    image: cakeImage3,
    theRecepie: `
    Chocolate Base:

    200 grams dark chocolate
    
    200 grams butter
    
    1 cup sugar
    
    4 eggs
    
    1.5 cups self-rising flour
    
    Cheese Cream:
    
    500 grams cream cheese
    
    1/2 cup powdered sugar
    
    1 teaspoon vanilla extract
    
    250 ml heavy cream
    
    Decoration:
    
    Sugar flowers or natural flowers
    
    Instructions:
    
    Melt chocolate and butter, add sugar and eggs gradually.
    
    Add flour and mix until smooth.
    
    Bake in a pan at 170°C (340°F) for about 35 minutes.
    
    Whip all the cream ingredients together.
    
    Layer cake – cream – cake – cream, leaving the sides exposed ("naked").
    
    Decorate gently with white flowers.
    `
  },
  {
    id: 4,
    name: "White Wedding Cake with Flowers",
    image: cakeImage4,
    theRecepie: `
    Ingredients:

    Vanilla/chocolate cake base in three different-sized pans
    
    White fondant
    
    Stable whipped cream for coating
    
    Sugar pearls for decoration
    
    Sugar paste flowers
    
    Instructions:
    
    Bake 3 layers in different sizes.
    
    Coat each layer with whipped cream and cover with fondant.
    
    Stack the layers on top of each other.
    
    Decorate with pearls and flowers.
    `
  },
  {
    id: 5,
    name: "🍓 Fruit and Cream Cake with Decorations",
    image: cakeImage5,
    theRecepie: `
    Ingredients for the cake:

    5 eggs
    
    1 cup sugar
    
    1 cup oil
    
    1 cup milk
    
    2 teaspoons vanilla extract
    
    2.5 cups self-rising flour
    
    For the cream:
    
    500 ml heavy cream
    
    1/2 cup powdered sugar
    
    Pink food coloring
    
    Decoration:
    
    Berries, mandarins, golden decorations
    
    Instructions:
    
    Beat eggs and sugar until light and fluffy.
    
    Add oil, milk, and vanilla extract and mix.
    
    Add flour and mix until smooth.
    
    Divide the batter into two pans and bake at 170°C (340°F) for about 30 minutes.
    
    Whip the cream, color it pink, and spread between the layers and around the cake.
    
    Decorate with fruits and decorations of your choice.
    `
  },
  {
    id: 6,
    name: "Vanilla Cake with Vanilla Cream and Berries",
    image: cakeImage6,
    theRecepie: `
    🧁 For the cake (2 round pans, 20 cm):
    4 eggs-
    
    1 cup sugar-
    
    1 cup canola oil-
    
    1 cup milk-
    
    1 tablespoon vanilla extract-
    
    2 cups self-rising flour-
    
    Pinch of salt
    
    🥣 Instructions:
    Preheat the oven to 180°C (350°F).
    
    Beat eggs and sugar for about 5 minutes until light and fluffy.
    
    Add oil, milk, and vanilla extract – beat a little more.
    
    Sift in the flour and salt and mix gently.
    
    Divide into 2 round baking pans and bake for 25–30 minutes until a toothpick comes out clean.
    
    Cool completely before frosting.
    
    🍦 For the vanilla cream frosting:
    500 ml heavy whipping cream (or non-dairy cream)-
    
    2 tablespoons instant vanilla pudding mix-
    
    3 tablespoons powdered sugar-
    
    1/2 teaspoon vanilla extract-
    
    (Optional: mascarpone or whipped non-dairy cream for stability)-
    
    Whip everything together until a stable and soft cream forms.
    
    🍓 For decoration:
    Red raspberries-
    Blueberries-
    Blackberries (or sliced strawberries)-
    Fresh mint leaves-
    Sliced almonds or grated white chocolate (optional)-
    
    🧑‍🍳 Assembly:
    Place one cake layer.
    
    Spread a layer of cream, fruits, then another cake layer.
    
    Coat the entire cake with smooth cream on the outside (can be rustic style as in the picture).
    
    Decorate with whipped cream, fresh fruits, and mint leaves.
    `
  },
  {
    id: 7,
    name: "🎉 Colorful Birthday Cake",
    image: cakeImage7,
    theRecepie: `
    🎂 For the cake (round pan 22–24 cm):

    2 cups flour
    
    2 teaspoons baking powder
    
    1/2 teaspoon salt
    
    200 grams butter
    
    1.5 cups sugar
    
    4 eggs
    
    1 tablespoon vanilla extract
    
    3/4 cup milk
    
    1/3 cup edible confetti
    
    🎂 For the colorful buttercream:
    
    250 grams butter
    
    400 grams powdered sugar
    
    1 tablespoon milk
    
    Pink and blue food coloring
    
    Edible confetti for decoration
    
    Instructions:
    
    Mix the dry ingredients. In a separate bowl, whip butter and sugar.
    
    Add eggs, vanilla, and milk alternately with the flour. Fold in the confetti.
    
    Bake for about 35 minutes. Cool completely.
    
    Prepare the cream in colors, decorate with piping tips, and stick confetti.
    `
  },
  {
    id: 8,
    name: "🎉 Vanilla Mousse Cake with Colorful Sprinkles",
    image: cakeImage8,
    theRecepie: `
    Ingredients:

    2 layers of biscuits/sponge cake
    
    2 containers of heavy whipping cream
    
    1 instant vanilla pudding mix
    
    1/2 cup milk
    
    Colorful sprinkles for decoration
    
    Instructions:
    
    Whip cream, milk, and pudding mix until a stable mousse forms.
    
    Place a layer of biscuits, a layer of mousse, then repeat with biscuits and mousse.
    
    Chill for at least 4 hours.
    
    Sprinkle colorful sprinkles before serving.
    `
  },
  {
    id: 9,
    name: "🌈 Rainbow Cake with Candles",
    image: cakeImage9,
    theRecepie: `
    Colorful Vanilla Base:

    2 cups flour
    
    2 teaspoons baking powder
    
    1/2 teaspoon salt
    
    1 cup butter
    
    1.5 cups sugar
    
    4 eggs
    
    3/4 cup milk
    
    Food coloring: red, orange, yellow, green, blue, purple
    
    Buttercream:
    
    250 grams butter
    
    2.5 cups powdered sugar
    
    2 teaspoons vanilla extract
    
    Decoration:
    
    Colorful sprinkles, candles
    
    Instructions:
    
    Prepare a basic batter and divide it into 6 bowls.
    
    Add a different food coloring to each bowl.
    
    Bake each color separately (small pans) or layer by layer.
    
    Cool, stack the layers with cream in between.
    
    Coat with white vanilla cream, decorate with sprinkles and candles.
    `
  }
];

export default RecepiesList;